export default {
  refreshYourResults: 'Actualiza los resultados',
  weNeedTo: 'Para ver la disponibilidad y los precios más recientes, debemos',
  refreshResults: 'actualizar los resultados.',
  okRefresh: 'De acuerdo, actualízalos',
}
